import { motion } from "framer-motion";

/**
 * Reusable luxury layout for legal / policy / about pages.
 * - Mobile-first responsive
 * - Preserves newlines via whitespace-pre-line
 * - Premium typography matching brand
 */
export default function LegalLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <div className="pt-28 md:pt-32 pb-20 min-h-screen bg-white" data-testid={`page-${(title || "").toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14"
        >
          {eyebrow && <div className="overline mb-3 text-[#C9A961]">{eyebrow}</div>}
          <h1 className="font-serif-display text-4xl md:text-6xl tracking-tighter font-light leading-[1.05]">
            {title}
          </h1>
          {lastUpdated && (
            <div className="text-xs text-[#5C5C5C] mt-4 uppercase tracking-wider">
              Last updated · {lastUpdated}
            </div>
          )}
        </motion.div>

        <div className="prose-blisson space-y-7 text-[15px] leading-relaxed text-[#3a3a3a]">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-serif-display text-2xl md:text-3xl tracking-tight font-medium text-black">
        {heading}
      </h2>
      <div className="space-y-3 text-[15px] leading-relaxed whitespace-pre-line">
        {children}
      </div>
    </section>
  );
}
